import { requestWithFallback } from '../httpClient';

export async function listNotificaciones(token, params = {}) {
    const result = await requestWithFallback({
        moduleName: 'notificaciones',
        endpoint: 'list',
        endpointIsKey: true,
        method: 'get',
        token,
        params,
    });

    return result.data;
}

export async function createNotificacion(token, payload) {
    const result = await requestWithFallback({
        moduleName: 'notificaciones',
        endpoint: 'create',
        endpointIsKey: true,
        method: 'post',
        token,
        data: payload,
    });

    return result.data;
}

export async function markNotificacionAsRead(token, notificationId) {
    const result = await requestWithFallback({
        moduleName: 'notificaciones',
        endpoint: 'markRead',
        endpointIsKey: true,
        method: 'post',
        token,
        pathParams: { id: notificationId },
    });

    return result.data;
}

export async function markAllNotificacionesAsRead(token) {
    const result = await requestWithFallback({
        moduleName: 'notificaciones',
        endpoint: 'markAllRead',
        endpointIsKey: true,
        method: 'post',
        token,
    });

    return result.data;
}
